<template>
  <v-container fluid class="fabill-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tab :href="`#tab-fabill`" class="mr-5">
            <v-icon class="mr-3">mdi-text-box-outline</v-icon>
            Asset Bill
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-items`" >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Items
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-depreciation`" >
            <v-icon class="mr-3">mdi-format-list-bulleted-type</v-icon>
            Depreciation
          </v-tab>
          <v-tab :href="`#tab-files`" class="mr-5">
            <v-icon class="mr-3">mdi-file-pdf-box</v-icon>
            Files
          </v-tab>
          <v-tab-item :value="'tab-fabill'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Asset Bill</p>
                      <v-select
                        readonly
                        class="mb-4"
                        :items="assettype"
                        v-model="edit_fabill.assettype"
                        v-on:change="onChangeBill($event, 'assettype')"
                        v-bind:error="error == 'assettype'"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line
                        hint="Please choose the asset type"
                      >
                      </v-select>
                      <v-menu
                        :readonly="isNotEditable"
                        ref="menu_assetdate"
                        v-model="menu_assetdate"
                        :close-on-content-click="false"
                        :return-value.sync="assetdate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :readonly="isNotEditable"
                            class="mb-2"
                            outlined
                            dense
                            v-model="assetdate"
                            label="Purchase Date"
                            v-bind="attrs"
                            v-bind:value="assetdate"
                            v-on:change="
                              onChangeBill($event, 'assetdate')
                            "
                            v-bind:error="error == 'assetdate'"
                            v-on="on"
                            single-line
                            hint="Enter asset purchase date"
                            persistent-hint
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          :readonly="isNotEditable"
                          v-model="assetdate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_assetdate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              onChangeBill(
                                assetdate,
                                'assetdate'
                              );
                              $refs.menu_assetdate.save(assetdate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-menu
                        ref="menu_assetstartdate"
                        v-model="menu_assetstartdate"
                        :close-on-content-click="false"
                        :return-value.sync="assetstartdate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :readonly="isNotEditable"
                            class="mb-2"
                            outlined
                            dense
                            v-model="assetstartdate"
                            label="Start Date"
                            v-bind="attrs"
                            v-bind:value="assetstartdate"
                            v-on:change="
                              onChangeBill($event, 'assetstartdate')
                            "
                            v-bind:error="error == 'assetstartdate'"
                            v-on="on"
                            single-line
                            hint="Enter asset start date"
                            persistent-hint
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          :readonly="isNotEditable"
                          v-model="assetstartdate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_assetstartdate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              onChangeBill(
                                assetstartdate,
                                'assetstartdate'
                              );
                              $refs.menu_assetstartdate.save(assetstartdate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>

                      <v-select
                        class="mb-4"
                        :items="['New', 'Pending', 'Completed']"
                        v-model="edit_fabill.assetstatus"
                        v-on:change="onChangeBill($event, 'assetstatus')"
                        outlined
                        dense
                        placeholder="Status"
                        persistent-hint
                        single-line
                        hint="Please choose the status"
                      >
                      </v-select>

                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        readonly
                        class="mb-4"
                        append-icon="mdi-magnify"
                        placeholder="Vendor Name"
                        single-line hint="Select the Vendor"
                        outlined
                        dense
                        @click:append="searchVendorDialog"
                        persistent-hint
                        v-model="edit_fabill.vendorname"
                        v-bind:error="error == 'vendorid'"
                      >
                      </v-text-field>  
                      <v-text-field
                        :readonly="isNotEditable"
                        class="mb-4"
                        v-model="edit_fabill.assetname"
                        v-on:change="
                          onChangeBill($event, 'assetname')
                        "
                        outlined
                        v-bind:error="error == 'assetname'"
                        dense
                        placeholder="Asset Name"
                        persistent-hint
                        single-line
                        hint="Enter the asset name"
                      >
                      </v-text-field>
                      <v-text-field
                        :readonly="isNotEditable"
                        class="mb-4"
                        v-model="edit_fabill.refnum"
                        v-on:change="
                          onChangeBill($event, 'refnum')
                        "
                        outlined
                        dense
                        placeholder="Ref Num"
                        persistent-hint
                        single-line
                        hint="Enter the invoice or ref num"
                      >
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="locations.map(x => {return {text: x.locationname, value: x._id};})"
                        v-model="edit_fabill.locationid"
                        v-on:change="onChangeBill($event, 'locationid')"
                        v-bind:error="error == 'locationid'"
                        outlined
                        dense
                        placeholder="Location"
                        persistent-hint
                        single-line hint="Please choose the location">
                      </v-select>
                      <v-select
                        v-if="type=='service'"
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="departments.map(x => {return {text: x.departmentname, value: x._id};})"
                        v-model="edit_fabill.departmentid"
                        v-on:change="onChangeBill($event, 'departmentid')"
                        v-bind:error="error == 'departmentid'"
                        outlined
                        dense
                        placeholder="Department"
                        persistent-hint
                        single-line hint="Please choose the department">
                      </v-select>
                      <v-select
                        v-if="type=='rental'"
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="properties.map(x => {return {text: x.propertyname, value: x._id};})"
                        v-model="edit_fabill.propertyid"
                        v-on:change="onChangeBill($event, 'propertyid')"
                        v-bind:error="error == 'propertyid'"
                        outlined
                        dense
                        placeholder="Property"
                        persistent-hint
                        single-line hint="Please choose the property">
                      </v-select>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="[{text: 'None', value: null}, ...saleschannels.map(x => {return {text: x.channelname, value: x._id};})]"
                        v-model="edit_fabill.channelid"
                        v-on:change="onChangeBill($event, 'channelid')"
                        v-bind:error="error == 'channelid'"
                        outlined
                        dense
                        placeholder="Channel"
                        persistent-hint
                        single-line hint="Please choose the channel">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-select
                          :readonly="isNotEditable"
                          class="mb-2"
                          :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                          v-on:change="onChangeBill($event, 'primaryCurrency')"
                          v-bind:value="edit_fabill.primaryCurrency"
                          v-bind:error="error == 'primaryCurrency'"
                          outlined
                          dense
                          placeholder="Currency 1"
                          persistent-hint
                          single-line hint="Currency 1">
                      </v-select>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-select
                          :readonly="isNotEditable"
                          class="mb-2"
                          :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                          v-on:change="onChangeBill($event, 'secondaryCurrency')"
                          v-bind:error="error == 'secondaryCurrency'"
                          v-bind:value="edit_fabill.secondaryCurrency"
                          outlined
                          dense
                          placeholder="Currency 2"
                          persistent-hint
                          single-line hint="Currency 2">
                      </v-select>
                        </v-col>
                      </v-row>
                      <v-text-field
                        :readonly="isNotEditable"
                          class="mb-2"
                          v-bind:value="edit_fabill.currencyRate"
                          v-bind:error="error == 'currencyRate'"
                          v-on:change="onChangeBill($event, 'currencyRate')"
                          outlined
                          dense
                          placeholder="Rate"
                          persistent-hint
                          single-line hint="Enter the currency rate">
                        </v-text-field>
                        <v-textarea
                          class="mb-2"
                          :readonly="isNotEditable"
                          v-model="edit_fabill.fabillnote"
                          v-on:change="onChangeBill($event, 'fabillnote')"
                          dense
                          outlined
                          rows=1
                          label="Note"
                          hint="please enter the note"
                      ></v-textarea>
                      <v-switch
                        class="mt-0"
                        color="primary"
                        v-on:change="onChangeBill($event, 'isTaxable')"
                        v-model="edit_fabill.isTaxable"
                        v-bind:value="edit_fabill ? edit_fabill.isTaxable : false"
                        hint="Taxable"
                        persistent-hint
                      ></v-switch>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/fabill/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="updateBill()"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <p class="text-h5">Items</p>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="6" class="d-flex flex-end justify-md-end overflow-auto" align="right">
                    <v-btn
                      v-show="isEditable"
                      class="button-shadow mr-1"
                      color="success"
                      @click="isAddTransaction=true; new_transaction={}">
                      Add
                    </v-btn>
                    <v-btn
                      class="button-shadow mr-1"
                        to="/fabill/list"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                  </v-col>
                  </v-row>
                  <v-data-table
                    sort-by="transrank"
                    :headers="header_items"
                    :items="transactions"
                    :items-per-page="100"
                    :footer-props="footer"
                    class="elevation-0"
                  >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteTransaction" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ delete_transaction.itemdesc }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteTransaction = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTransaction(delete_transaction)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemimage="{ item }">
                          <v-img
                            v-bind:lazy-src="item.itemimage"
                            min-width="50"
                            max-width="100"
                            v-bind:src="item.itemimage"
                          ></v-img>
                        </template>
                        <template v-slot:item.accountid="{ item }">
                          {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
                        </template>
                        <template v-slot:item.itemamount="{ item }">
                          {{ item.itemamount.toFixed(2) }}
                        </template>
                        <template v-slot:item.transdate="{ item }">
                          {{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
                        </template>
                        <template v-slot:item.deptype="{ item }">
                            <p class="two-line">{{ item.deptype }}</p>
                          </template>
                          <template v-slot:item.deprate="{ item }">
                            <p class="two-line">Rate: {{ item.deprate!=null ? parseFloat(item.deprate).toFixed(2) : '' }}</p>
                            <p class="two-line">Value: {{ item.depvalue!=null ? parseFloat(item.depvalue).toFixed(2) : '' }}</p>
                          </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="editTransactionDialog(item)"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="deleteTransactionDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-depreciation'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <p class="text-h5">Depreciation</p>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="6" class="d-flex flex-end justify-md-end overflow-auto" align="right">
                    <v-btn
                      v-show="isEditable"
                      class="button-shadow mr-1"
                      color="success"
                      @click="isAddDepreciation=true; new_depreciation={}">
                      Add
                    </v-btn>
                    <v-btn
                      class="button-shadow mr-1"
                        to="/fabill/list"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                  </v-col>
                  </v-row>
                  <v-data-table
                    sort-by="transdate"
                    sort-desc
                    :headers="header_depreciations"
                    :items="depreciations"
                    :items-per-page="100"
                    :footer-props="footer"
                    class="elevation-0"
                  >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteDepreciation" width="500">
                            <v-card>
                              <v-card-title> Delete this Entry? </v-card-title>
                              <v-card-text>
                                {{ delete_depreciation.transdesc }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteDepreciation = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteDepreciation(delete_depreciation)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.debit_accountid="{ item }">
                          {{ accounts.length>0 ? accounts.find(account=>account._id == item.debit_accountid)['accountname'] : '' }}
                        </template>
                        <template v-slot:item.credit_accountid="{ item }">
                          {{ accounts.length>0 ? accounts.find(account=>account._id == item.credit_accountid)['accountname'] : '' }}
                        </template>
                        <template v-slot:item.transamount="{ item }">
                          {{ item.transamount.toFixed(2) }}
                        </template>
                        <template v-slot:item.transdate="{ item }">
                          {{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
                        </template>
                        <template v-slot:item.deptype="{ item }">
                          <p class="two-line">{{ item.deptype }}</p>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="editDepreciationDialog(item)"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="deleteDepreciationDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-files'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                        <v-col md="11">
                          <p class="text-h5">Files</p>
                        </v-col>
                        <v-col md="1">
                          <v-btn
                            class="button-shadow"
                            color="secondary"
                            @click="isUploadFile = true"
                          >
                            Add
                          </v-btn>
                        </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="header_file"
                        :items="files"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteFile" width="500">
                            <v-card>
                              <v-card-title> Delete this File? </v-card-title>
                              <v-card-text>
                                {{ delete_file.filename }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteFile = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteFile(delete_file)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.filetype="{ item }">
                            <a v-if="item.filetype=='pdf'" :href="item.fileurl" style="text-decoration: none !important;">
                              <v-icon 
                            size="50"
                            color="primary"
                            >
                              mdi-file-pdf-box
                            </v-icon></a>    
                        </template>
                        <template v-slot:item.filesize="{ item }">
                            {{ (item.filesize/1000).toFixed(0) + " KB"  }}    
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                          {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}
                        </template>
                        <template v-slot:item.actions="{ item }">

                          <v-btn
                            icon
                            color="primary"
                            @click="deleteFileDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>

                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/fabill/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="data_accounts"
                    v-model="new_transaction.accountid"
                    v-bind:error="error == 'accountid'"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="new_transaction.itemdesc"
                    v-bind:error="error == 'itemdesc'"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.itemamount"
                    v-bind:error="error == 'itemamount'"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    class="mb-4"
                    :items="['Rate', 'Value']"
                    v-model="new_transaction.deptype"
                    v-bind:error="error == 'deptype'"
                    outlined
                    dense
                    placeholder="Type"
                    persistent-hint
                    single-line hint="Depreciation Type">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.deprate"
                    v-bind:error="error == 'deprate'"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Rate"
                    persistent-hint
                    single-line hint="Depreciation Rate">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.depvalue"
                    v-bind:error="error == 'depvalue'"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Value"
                    persistent-hint
                    single-line hint="Depreciation Value">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="insertTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isAddDepreciation"
        persistent
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Depreciation</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="[{text: 'None', value: null}, ...initvalue.transactions.map(x => {return {text: x.itemdesc, value: x._id};}) ]"
                    v-model="new_depreciation.fa_itemid"
                    v-bind:error="error == 'fa_itemid'"
                    v-on:change="onChangeItem($event, 'fa_itemid')"
                    outlined
                    dense
                    placeholder="Asset Item"
                    persistent-hint
                    single-line hint="Asset Item">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="data_expense_accounts"
                    v-model="new_depreciation.debit_accountid"
                    v-bind:error="error == 'debit_accountid'"
                    outlined
                    dense
                    placeholder="Debit Account"
                    persistent-hint
                    single-line hint="Debit Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="data_accumulation_accounts"
                    v-model="new_depreciation.credit_accountid"
                    v-bind:error="error == 'credit_accountid'"
                    outlined
                    dense
                    placeholder="Credit Account"
                    persistent-hint
                    single-line hint="Credit Account">
                  </v-select>
                </v-col>



              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-menu
                    ref="menu_transdate"
                    v-model="menu_transdate"
                    :close-on-content-click="false"
                    :return-value.sync="new_depreciation.transdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="new_depreciation.transdate"
                        label="Transaction Date"
                        v-bind="attrs"
                        v-bind:value="new_depreciation.transdate"
                        v-bind:error="error == 'transdate'"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please choose the transaction date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="new_depreciation.transdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_transdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_transdate.save(new_depreciation.transdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="new_depreciation.transdesc"
                    v-bind:error="error == 'transdesc'"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="new_depreciation.transamount"
                    v-bind:error="error == 'transamount'"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddDepreciation=false; add_depreciation={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="insertDepreciation"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="data_accounts"
                    v-model="edit_transaction.accountid"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="edit_transaction.itemdesc"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.itemamount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    class="mb-4"
                    :items="['Rate', 'Value']"
                    v-model="edit_transaction.deptype"
                    outlined
                    dense
                    placeholder="Type"
                    persistent-hint
                    single-line hint="Depreciation Type">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.deprate"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Rate"
                    persistent-hint
                    single-line hint="Depreciation Rate">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.depvalue"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Value"
                    persistent-hint
                    single-line hint="Depreciation Value">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditDepreciation"
        persistent
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Depreciation</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items="data_expense_accounts"
                    v-model="edit_depreciation.debit_accountid"
                    v-bind:error="error == 'debit_accountid'"
                    outlined
                    dense
                    placeholder="Debit Account"
                    persistent-hint
                    single-line hint="Debit Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items="data_accumulation_accounts"
                    v-model="edit_depreciation.credit_accountid"
                    v-bind:error="error == 'credit_accountid'"
                    outlined
                    dense
                    placeholder="Credit Account"
                    persistent-hint
                    single-line hint="Credit Account">
                  </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-menu
                    ref="menu_transdate_edit"
                    v-model="menu_transdate_edit"
                    :close-on-content-click="false"
                    :return-value.sync="edit_depreciation.transdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="edit_depreciation.transdate"
                        label="Transaction Date"
                        v-bind="attrs"
                        v-bind:value="edit_depreciation.transdate"
                        v-bind:error="error == 'transdate'"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please choose the transaction date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="edit_depreciation.transdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_transdate_edit = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_transdate_edit.save(edit_depreciation.transdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="edit_depreciation.transdesc"
                    v-bind:error="error == 'transdesc'"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_depreciation.transamount"
                    v-bind:error="error == 'transamount'"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditDepreciation=false; edit_depreciation={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateDepreciation"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isUploadFile"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Upload File</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                <v-file-input label="File input" v-model="upload_file.file" v-on:change="onChangeFile" accept=".pdf" />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="upload_file.filename"
                    label="File Name"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isUploadFile = false; upload_file.file=null; upload_file.filename=''"
            >
              Close
            </v-btn>
            <v-btn
              :disabled="upload_file.file==null"
              color="blue darken-1"
              text
              @click="uploadFile"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatStdDate } from '@/mixins/date';
import router from "@/Routes";

export default {
  data() {
    return {
      header_items: [
        { text: 'Date', value: 'transdate', width: '8%'},
        { text: 'Account', value: 'accountid', width: '30%'},
        { text: 'Description', value: 'itemdesc'},
        { text: 'Depreciation', value: 'deptype', width: '10%'},
        { text: 'Rate|Value', value: 'deprate', width: '15%'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
        { text: "Actions", value: "actions", sortable: false, width: '10%' },
      ],
      header_depreciations: [
        { text: 'Date', value: 'transdate', width: '8%'},
        { text: 'Debit Account', value: 'debit_accountid', width: '20%'},
        { text: 'Credit Account', value: 'credit_accountid', width: '20%'},
        { text: 'Description', value: 'transdesc'},
        { text: 'Amount', value: 'transamount', width: '10%'},
        { text: "Actions", value: "actions", sortable: false, width: '10%' },
      ],
      header_file: [
        { text: "Type", value: "filetype" },
        { text: "Name", value: "filename" },
        { text: "Size", value: "filesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      
      search_vendor: {},
      initvalue: {},
      change_fabill: {},

      new_transaction: {},
      new_depreciation: {},
      edit_fabill: {},
      edit_transaction: {},
      edit_depreciation: {},
      delete_transaction: {},
      delete_depreciation: {},
      delete_file: {},

      upload_file: {filename: null,file: null},
      files: [],
      transactions: [],
      depreciations: [],
      assettype: ["Fixed Asset", "Month Expense Bill", ],
      footer: {'items-per-page-options': [500, 1000, 5000]},

      menu_transdate: false,
      menu_transdate_edit: false,
      
      accountsubclass: null,
      accountsubclass2: null,

      assetdate: null,
      assetstartdate: null,
      menu_assetdate: false,
      menu_assetstartdate: false,

      isEditTransaction: false,
      isEditDepreciation: false,
      isAddTransaction: false,
      isAddDepreciation: false,
      isUploadFile: false,
      isDeleteFile: false,
      isDeleteTransaction: false,
      isDeleteDepreciation: false,    
      error: null,
      isRental: false,
      type: null,
    };
  },
  computed: {
    ...mapState("Account", ["accounts"]),
    ...mapState("FABill", ["isReceiving"]),
    ...mapState("Department", ["departments"]),
    ...mapState("Location", ["locations"]), 
    ...mapState("Property", ["properties"]),  
    ...mapState("SalesChannel", ["saleschannels"]),
    isNotEditable(){
      let result = ['New','Credit','Partial','Pending','Audit','Void'].indexOf(this.initvalue.assetstatus) == -1;
      return result;
    },
    isEditable(){
      let result = ['New','Partial', 'Audit', 'Void'].indexOf(this.initvalue.assetstatus) >= 0;
      return result;
    },
    data_accounts(){
      let filter = this.accounts.filter(account=>account.accountsubclass=='Other Asset' && account.options!=null && account.options.isFixedAsset==true).map(x => {return {text: x.accountname, value: x._id}});
      return filter;
    },
    data_expense_accounts(){
      if(this.accounts==null) return [];
      let asset_accounts  = this.initvalue.transactions.map(i=>{return i.accountid});
      let filter = this.accounts.filter(i=>asset_accounts.includes(i._id)).map(i=>{return i.options.debit_accountid});
      let expense_accounts = this.accounts.filter(i=>filter.includes(i._id));
      return expense_accounts.map(x => {return {text: x.accountname, value: x._id}});
    },
    data_accumulation_accounts(){
      if(this.accounts==null) return [];
      let asset_accounts  = this.initvalue.transactions.map(i=>{return i.accountid});
      let filter = this.accounts.filter(i=>asset_accounts.includes(i._id)).map(i=>{return i.options.credit_accountid});
      let accumulation_accounts = this.accounts.filter(i=>filter.includes(i._id));
      return accumulation_accounts.map(x => {return {text: x.accountname, value: x._id}});
    },
  },
  methods: {
    ...mapActions("Account", ["getAccountsRequest"]),
    ...mapActions("FABill", ["getFABillRequest", "deleteFATransactionRequest", "deleteFADepreciationRequest", "insertFATransactionRequest", "insertFADepreciationRequest", "updateFABillRequest", "updateFATransaction", "updateFADepreciation" ]),
    ...mapActions("Department", ["getDepartmentsRequest"]),
    ...mapActions("File", ["insertRouteFile", "deleteFileRequest"]),
    ...mapActions("Location", ["getLocationsRequest"]),
    ...mapActions("Property", ["getPropertiesRequest"]),
    ...mapActions("SalesChannel", ["getSalesChannelsRequest"]),
    ...mapActions('SystemSetting', ["getSetting"]),
    checkTransaction(){
      if(!this.new_transaction.accountid){
        this.error = 'accountid';
        return false;
      }
      if(!this.new_transaction.itemdesc){
        this.error = 'itemdesc';
        return false;
      }
      if(!this.new_transaction.itemamount){
        this.error = 'itemamount';
        return false;
      }
      this.error = null;
      return true;
    },
    checkDepreciation(){
      if(!this.new_depreciation.debit_accountid){
        this.error = 'debit_accountid';
        return false;
      }
      if(!this.new_depreciation.credit_accountid){
        this.error = 'credit_accountid';
        return false;
      }
      if(!this.new_depreciation.transdate){
        this.error = 'transdate';
        return false;
      }
      if(!this.new_depreciation.transdesc){
        this.error = 'transdesc';
        return false;
      }
      if(!this.new_depreciation.transamount){
        this.error = 'transamount';
        return false;
      }
      this.error = null;
      return true;
    },
    clearTransaction() {
      this.edit_transaction = {};
      this.new_transaction = {};
    },
    deleteTransactionDialog(item) {
      this.isDeleteTransaction = true;
      this.delete_transaction = {_id: item._id, itemname: item.itemname, itemdesc: item.itemdesc};
    },
    async deleteTransaction(payload) {
      this.isDeleteTransaction = false;
      let response = await this.deleteFATransactionRequest(payload);
      let index = this.transactions.findIndex((trans) => trans._id == response._id);
      this.transactions.splice(index, 1);
      this.getFABillRequest(this.initvalue._id);
    },
    deleteDepreciationDialog(item) {
      this.isDeleteDepreciation = true;
      this.delete_depreciation = {_id: item._id, transdesc: item.transdesc};
    },
    async deleteDepreciation(payload) {
      this.isDeleteDepreciation = false;
      let response = await this.deleteFADepreciationRequest(payload);
      let index = this.depreciations.findIndex((trans) => trans._id == response._id);
      this.depreciations.splice(index, 1);
      this.getFABillRequest(this.initvalue._id);
    },
    deleteFileDialog(item) {
      this.isDeleteFile = true;
      this.delete_file = {_id: item._id,filename: item.filename,};
    },
    async deleteFile(payload) {
      this.isDeleteFile = false;
      let response = await this.deleteFileRequest(payload);
      let index = this.files.findIndex((trans) => trans._id == response._id);
      this.files.splice(index, 1);
    },
    async insertTransaction() {
      if(!this.checkTransaction()) return;
      let payload = Object.assign({fabillid: this.initvalue._id}, this.new_transaction);
      let response = await this.insertFATransactionRequest(payload);
      this.transactions.push(response);
      this.getFABillRequest(this.initvalue._id);
      this.clearTransaction();
      this.isAddTransaction = false;
    },
    async insertDepreciation() {
      if(!this.checkDepreciation()) return;
      let payload = Object.assign({fabillid: this.initvalue._id}, this.new_depreciation);
      let response = await this.insertFADepreciationRequest(payload);
      this.depreciations.push(response);
      this.getFABillRequest(this.initvalue._id);
      this.add_depreciation = {};
      this.isAddDepreciation = false;
    },
    editTransactionDialog(item) {
      let account = this.accounts.find(account=>account._id == item.accountid);
      this.accountsubclass2 = account.accountsubclass;
      this.edit_transaction = Object.assign({}, item);
      this.edit_transaction.transdate = formatStdDate(this.edit_transaction.transdate);
      this.isEditTransaction = true;
    },
    editDepreciationDialog(item) {
      this.edit_depreciation = Object.assign({}, item);
      this.edit_depreciation.transdate = formatStdDate(this.edit_depreciation.transdate);
      this.isEditDepreciation = true;
    },
    onChangeFile(file) {
      if (!file) this.upload_file.file = null;
      else this.upload_file.file = file;
    },
    onChangeBill(value, field) {
      this.change_fabill[field] = value;
    },
    onChangeItem(value, field) {
      console.log(value, field);
      let item = this.initvalue.transactions.find(i=>i._id==value);
      let account = this.accounts.find(a=>a._id==item.accountid);
      let amount = 0;
      if(item.deptype=='Rate') amount = (item.deprate * item.itemamount) / 12;
      else if(item.deptype=='Value') amount = (item.depvalue) / 12;

      this.new_depreciation = Object.assign({}, this.new_depreciation, {debit_accountid: account.options.debit_accountid, credit_accountid: account.options.credit_accountid})
      this.new_depreciation = Object.assign({}, this.new_depreciation, {transdesc: item.itemdesc, transamount: amount});


    },
    searchVendorDialog(){
      this.search_vendor = {};
      this.isSearchVendor = true;
    },
    async updateBill() {
      this.change_fabill._id = this.initvalue._id;
      await this.updateFABillRequest(this.change_fabill);
      router.push("/fabill/list");
    },
    async updateTransaction() {
      this.isEditTransaction = false;
      let response = await this.updateFATransaction(this.edit_transaction);
      let index = this.transactions.findIndex((x) => x._id == response._id);
      this.transactions.splice(index, 1, response);
      this.clearTransaction();
      this.getFABillRequest(this.initvalue._id);
    },
    async updateDepreciation() {
      this.isEditDepreciation = false;
      let response = await this.updateFADepreciation(this.edit_depreciation);
      let index = this.depreciations.findIndex((x) => x._id == response._id);
      this.depreciations.splice(index, 1, response);
      this.clearTransaction();
      this.getFABillRequest(this.initvalue._id);
    },
    async uploadFile(){
      this.isUploadFile = false;
      this.upload_file.id = this.initvalue._id;
      this.upload_file.route = 'fabill';
      let file = await this.insertRouteFile(this.upload_file);
      this.files.push(file);
      this.upload_file = {filename: null, file: null};
      this.getFABillRequest(this.initvalue._id);
    },
    getExpenseAccounts(){
      if(this.initvalue==null || this.initvalue.transactions==null) return [];
      let asset_accounts  = this.initvalue.transactions.map(i=>{return i.accountid});
      let filter = this.accounts.filter(i=>asset_accounts.includes(i._id)).map(i=>{return i.options.debit_accountid});
      let expense_accounts = this.accounts.filter(i=>filter.includes(i._id));
      return expense_accounts;
    }
  },

  async created() {
    this.initvalue = this.$route.params;
    if (!this.initvalue._id) this.$router.push({ name: "FABillList" });
    this.edit_fabill = Object.assign({}, this.initvalue);
    this.assetdate = formatStdDate(this.initvalue.assetdate);
    this.assetstartdate = formatStdDate(this.initvalue.assetstartdate);

    if (this.accounts.length==0) await this.getAccountsRequest();
    if (this.departments.length==0) await this.getDepartmentsRequest();
    if (this.properties.length==0) await this.getPropertiesRequest();
    if (this.saleschannels.length==0) await this.getSalesChannelsRequest();

    this.files = this.initvalue.files;
    this.transactions = Object.assign([], this.initvalue.transactions);
    this.depreciations = Object.assign([], this.initvalue.depreciations);
    this.getExpenseAccounts();

    this.isRental = await this.getSetting({code: 'CompanySettings', name: 'isRental'}, );
    this.isRental==true ? this.type='rental' : this.type='service';
  },
};
</script>

<style src="./Edit.scss" lang="scss"></style>
